import { Ng2StateDeclaration } from '@uirouter/angular';
import { Transition } from '@uirouter/core';

import { WikiPageComponent } from './page/wiki.page.component';
import { WikiHeaderComponent } from './header/wiki.header.component';
import { WikiBrowseComponent } from './browse/wiki.browse.component';

import { WikiResolvesService } from './wiki-resolves.service';

export const WIKI_STATES: any[] = [
    {
        name: 'home.project.summary.wiki',
        url: '/wiki',
        data: {
            searchContext: ['wiki']
        },
        redirectTo: (transition: Transition) => {
            return {
                state: 'home.project.summary.wiki.page',
                params: {
                    ...transition.params(),
                    pagename: 'FrontPage'
                }
            };
        },
        resolve: [
            {
                token: 'security',
                deps: ['project', WikiResolvesService],
                resolveFn: async (project: any, wikiResolvesService: WikiResolvesService) => {
                    return wikiResolvesService.security(project);
                }
            }
        ],
        views: {
            'contentarea@home.project.summary': {
                template: '<div ui-view></div>'
            }
        }
    },
    {
        // Wiki page surface: renders the self-contained <wiki-container> (tab bar + content +
        // save-on-leave). The container fetches its own page data; tab substates below are empty
        // URL markers the container reads to pick the active tab.
        name: 'home.project.summary.wiki.page',
        url: '?pagename',
        params: {
            pagename: {
                value: 'FrontPage',
                squash: true,
                raw: true
            }
        },
        resolve: [
            {
                token: 'tour',
                deps: ['project', WikiResolvesService],
                resolveFn: async (project: any, wikiResolvesService: WikiResolvesService) => {
                    return wikiResolvesService.getWikiTour(project);
                }
            }
        ],
        // Landing on the bare page shows the View tab.
        redirectTo: (transition: Transition) => ({
            state: 'home.project.summary.wiki.page.view',
            params: transition.params()
        }),
        views: {
            'projectheader@home.project.summary': {
                component: WikiHeaderComponent
            },
            'contentarea@home.project.summary': {
                component: WikiPageComponent
            }
        }
    },
    // Tab substates — empty URL markers; the container swaps content by reading the active state.
    { name: 'home.project.summary.wiki.page.view', url: '' },
    { name: 'home.project.summary.wiki.page.edit', url: '/edit' },
    { name: 'home.project.summary.wiki.page.versions', url: '/versions' },
    { name: 'home.project.summary.wiki.page.monitor', url: '/monitor' },
    { name: 'home.project.summary.wiki.page.referrers', url: '/referrers' },
    { name: 'home.project.summary.wiki.page.attachments', url: '/attachments' },
    {
        name: 'home.project.summary.wiki.browse',
        url: '/browse?page_num&page_size&sort_field&sort_dir&pagename&content&author&authorAnyVersion&createdDateFrom&createdDateTo&updatedDateFrom&updatedDateTo',
        reloadOnSearch: true,
        params: {
            page_num: {
                value: "1",
                squash: true
            },
            page_size: {
                value: "20",
                squash: true
            },
            sort_field: {
                value: 'pagename',
                squash: true
            },
            sort_dir: {
                value: 'asc',
                squash: true
            },
            pagename: {
                value: '',
                squash: true
            },
            content: {
                value: '',
                squash: true
            },
            author: {
                value: '',
                squash: true
            },
            authorAnyVersion: {
                value: '',
                squash: true
            },
            createdDateFrom: {
                value: '',
                squash: true
            },
            createdDateTo: {
                value: '',
                squash: true
            },
            updatedDateFrom: {
                value: '',
                squash: true
            },
            updatedDateTo: {
                value: '',
                squash: true
            }
        },
        resolve: [
            {
                token: 'security',
                deps: ['project', WikiResolvesService],
                resolveFn: async (project: any, wikiResolvesService: WikiResolvesService) => {
                    return wikiResolvesService.security(project);
                }
            },
            {
                token: 'tour',
                deps: [WikiResolvesService],
                resolveFn: async (wikiResolvesService: WikiResolvesService) => {
                    return wikiResolvesService.getBrowseTour();
                }
            }
        ],
        views: {
            'projectheader@home.project.summary': {
                component: WikiHeaderComponent
            },
            'contentarea@home.project.summary': {
                component: WikiBrowseComponent
            }
        }
    }
];